import _ from 'lodash'
import { dollarFormat, numeralFormat } from '../../../../../../../../lib/renderUtil'
import {
  ChartToolTip,
  Title,
  Item,
  ItemIcon
} from '../../../../../../Common/NewDashboard/Chart/ToolTip'
import {
  FIELD as TABLE_FIELD,
  FIELD_MAP as TABLE_FIELD_MAP
} from '../../SummariesTable/SummariesTable'

export const getFormattedValue = (payload, sortType) => {
  const currentValue = _.toNumber(payload[sortType])
  let formattedValue
  switch (sortType) {
    case TABLE_FIELD.AMOUNT: {
      formattedValue = dollarFormat(currentValue)
      break
    }
    case TABLE_FIELD.QUANTITY:
    case TABLE_FIELD.LISTING_COUNT: {
      formattedValue = numeralFormat(currentValue, { allowZero: true })
      break
    }
    default:
      break
  }
  return formattedValue
}

const CustomizedTooltip = props => {
  const { active, payload, sortType } = props
  const currentPayload = _.get(payload, '0.payload', {})
  const {
    fill,
    reason,
    percent
  } = currentPayload
  if (active) {
    return (
      <ChartToolTip>
        <Title>
          <ItemIcon color={fill} />
          {` ${reason}`}
        </Title>
        <Item>
          {`${TABLE_FIELD_MAP[sortType]} : ${getFormattedValue(currentPayload, sortType)}`}
        </Item>
        <Item>
          {`佔比 : ${percent}%`}
        </Item>
      </ChartToolTip>
    )
  }
  return null
}

export default CustomizedTooltip
